// extracted by mini-css-extract-plugin
export var buttonContainer = "_54-1";
export var fontSizeSelect = "_54-3";
export var formatSelect = "_54-2";
export var formats = "_54-4";
export var hidden = "_54-5";
export var icon = "_54-6";
export var select = "_54-0";